const config = {
  apiUrl: process.env.REACT_APP_API_URL || '/outcomes',
  baseUrl: process.env.REACT_APP_API_URL || '/outcomes',
};

export default config;
